<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import Contact from "../components/Contact.svelte";
	import HelpSection from "../components/HelpSection.svelte";
	import DecoratedHeadline from "../components/DecoratedHeadline.svelte";
	import BlogPostCard from "../components/BlogPostCard.svelte";
	import Button from "../components/Button.svelte";
	import type { BlogProps } from "./BlogProps.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { tick } from "svelte";

	type $$Props = BlogProps;

	const { blogPosts } = $$restProps as $$Props;

	let visibleArticles = 6;

	async function handleLoadMore(): Promise<void> {
		const referencesContainer = document.getElementById("blog") as HTMLDivElement;

		const initialScrollHeight = referencesContainer.scrollHeight;
		const previousLastReference = referencesContainer.lastElementChild;

		visibleArticles += 3;

		await tick();
		const firstNewReference = previousLastReference?.nextElementSibling ?? referencesContainer.lastElementChild;

		if (firstNewReference) {
			const offset = 100;

			const newReferencePosition = firstNewReference.getBoundingClientRect().top + window.scrollY - offset;
			const finalScrollHeight = referencesContainer.scrollHeight;
			const heightDifference = finalScrollHeight - initialScrollHeight;

			const adjustedPosition =
				heightDifference > 0 ? Math.min(newReferencePosition, window.scrollY + heightDifference) : newReferencePosition;

			window.scrollTo({
				top: adjustedPosition,
				behavior: "smooth",
			});
		}
	}
</script>

<Layout>
	<div class="mt-20 flex flex-col items-center px-4 text-center lg:px-8">
		<DecoratedHeadline h1>Píšeme o logistice</DecoratedHeadline>
		<p
			class="my-6 max-w-[70.625rem] text-lg font-bold leading-[1.25] text-gray-400 sm:text-[2rem] md:text-[3rem] lg:mt-16"
		>
			{nbspify(
				"Logistika a skladování jsou základem efektivního podnikání. Kdo dokáže skladovat chytře, dodávat rychle a bez chyb, získává klíčovou výhodu nad konkurencí.",
			)}
		</p>
		<p class="text-bito-black max-w-[50.25rem] text-xs md:text-base lg:mt-8">
			{nbspify(
				"A právě o těchto tématech u nás najdete články! Logistika nabízí obrovský potenciál úspor a zlepšení procesů. Naším cílem je přiblížit vám nejen intralogistiku – tedy skladovací systémy, kompletační zařízení a materiálové toky – ale i širší souvislosti, trendy a inovace ze světa logistiky. Inspirujte se našimi postřehy a podívejte se na logistiku z nové perspektivy.",
			)}
		</p>
	</div>

	<div
		id="blog"
		class="mt-16 flex flex-wrap justify-center gap-x-[1.25rem] gap-y-16 sm:container lg:justify-start xl:grid xl:grid-cols-3"
	>
		{#each blogPosts.slice(0, visibleArticles) as blogPost}
			<BlogPostCard {blogPost} />
		{/each}
	</div>

	{#if visibleArticles < blogPosts.length}
		<div class="mt-20 flex justify-center px-4">
			<Button variant="secondary" class="w-full max-w-[27.5rem]" on:click={handleLoadMore}>
				{nbspify("Načíst další blogy")}
			</Button>
		</div>
	{/if}

	<div class="mt-20 flex flex-col gap-20 lg:mt-32 lg:gap-32">
		<HelpSection />
		<Contact />
	</div>
</Layout>
